class PackagingOptionsSelector extends HTMLElement {
    constructor() {
        super();

        this.selectedPackagingItems = null;

        // Number of Added produts into cart (Except packaging & customizing items)
        this.cartItemsCount = this.dataset.cartItemsCount;

        // Packaging Items
        this.packagingItems = this.querySelectorAll(".options-wrapper .option-item");
        this.packagingItems.forEach(el => el.addEventListener("click", () => this.selectPackagingItem(el.querySelector("input[name='id']").value, el.querySelector("input[name='qty']").value)));

        // Packaging Item Quantity Selectors
        this.quantitySelectors = this.querySelectorAll("quantity-input input[name='quantity']");
        this.quantitySelectors.forEach(el => el.addEventListener("change", () => {
            el.closest(".option-item").querySelector("input[name='qty']").value = el.value;
            if (el.closest(".option-item").querySelector("input[type='radio']")) {
                el.closest(".option-item").querySelector("input[type='radio']").checked = true;
            }
        }));

        // Popup
        this.popup = this.querySelector(".options-popup-wrapper");

        // Popup Open Button
        this.openPopupBtn = this.querySelector("button[toggle-btn]");
        this.openPopupBtn.addEventListener("click", () => this.openPopup());

        // Popup Close Button
        this.closePopupBtn = this.querySelector(".close-btn");
        this.closePopupBtn.addEventListener("click", () => this.closePopup());

        // Popup Add Packaging Button
        this.addPackagingItemBtn = this.querySelector("button.add-button");
        this.addPackagingItemBtn.addEventListener("click", () => this.addPackagingOption());

        // "Suggested Packaging Product" Select Button
        this.suggestedPackagingProductBtns = this.querySelectorAll(".suggested-packaging-option button");
        if (this.suggestedPackagingProductBtns && this.suggestedPackagingProductBtns.length) {
            this.suggestedPackagingProductBtns.forEach(btn => {
                btn.addEventListener("click", () => {
                    const suggestedPackagingProduct = {
                        id: this.packagingItems[0].querySelector("input[name='id']").value,
                        qty: 1
                    };
                    this.addSuggestedPackagingOption(suggestedPackagingProduct, btn);
                });
            })
        }
    }

    selectPackagingItem(id, qty) {
        this.selectedPackagingItems = [{
            id: Number(id),
            quantity: Number(qty)
        }];
        this.addPackagingItemBtn.removeAttribute("disabled");
    }

    addPackagingOption() {
        if (this.cartItemsCount > 1) {
            this.selectedPackagingItems = Array.from(this.packagingItems).filter(el => !!Number(el.querySelector("input[name='qty']").value)).map(el => {
                return {
                    id: Number(el.querySelector("input[name='id']").value),
                    quantity: Number(el.querySelector("input[name='qty']").value)
                }
            });

            if (!this.selectedPackagingItems.length) {
                this.closePopup();
                return;
            }
        }

        // Check if cart has packaging items
        this.addPackagingItemBtn.setAttribute("disabled", "");
        this.getCart().then(cart => {
            const packagingItems = Array.from(this.packagingItems).map(el => Number(el.querySelector("input[name='id']").value));
            const cartPackagingItems = cart.items.filter(el => !!packagingItems.some(elem => elem == el.id)).map(el => el.id);

            if (cartPackagingItems.length && this.cartItemsCount == 1) {
                // Delete packaging items which added into cart
                this.removeFromCart(cartPackagingItems).then(res => {
                    this.addToCart().then(res => {
                        this.closePopup();
                        setTimeout(() => {
                            window.location.reload();
                        }, 300);
                    });
                })
            } else {
                // Add selected packaging item into cart
                this.addToCart().then(res => {
                    this.closePopup();
                    setTimeout(() => {
                        window.location.reload();
                    }, 300);
                });
            }
        })
            .catch(err => {
                // Handle the error
                console.error('Error:', err);
            });
    }

    openPopup() {
        this.popup.removeAttribute("hidden");
    }

    closePopup() {
        this.popup.setAttribute("hidden", "");
    }

    getCart() {
        return new Promise((resolve, reject) => {
            fetch('/cart.js', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(res => res.json())
                .then(cart => {
                    resolve(cart);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    addToCart() {
        return new Promise((resolve, reject) => {
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ "items": this.selectedPackagingItems })
            }).then(res => res.json())
                .then(data => {
                    resolve(data);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    removeFromCart(cartPackagingItems) {
        const updates = {};
        Array.from(cartPackagingItems).forEach(el => updates[el] = 0);
        return new Promise((resolve, reject) => {
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
            }).then(res => res.json())
                .then(data => {
                    resolve(data);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }


    addSuggestedPackagingOption(product, btn) {
        // Select the suggested item
        this.selectedPackagingItems = [{
            id: Number(product.id),
            quantity: Number(product.qty)
        }];

        // Check if cart has packaging items
        btn.setAttribute("disabled", "");
        this.getCart().then(cart => {
            const packagingItems = Array.from(this.packagingItems).map(el => Number(el.querySelector("input[name='id']").value));
            const cartPackagingItems = cart.items.filter(el => !!packagingItems.some(elem => elem == el.id)).map(el => el.id);

            if (cartPackagingItems.length && this.cartItemsCount == 1) {
                // Delete packaging items which added into cart
                this.removeFromCart(cartPackagingItems).then(res => {
                    this.addToCart().then(res => {
                        this.closePopup();
                        setTimeout(() => {
                            window.location.reload();
                        }, 300);
                    });
                })
            } else {
                // Add selected packaging item into cart
                this.addToCart().then(res => {
                    this.closePopup();
                    setTimeout(() => {
                        window.location.reload();
                    }, 300);
                });
            }
        })
            .catch(err => {
                // Handle the error
                console.error('Error:', err);
            });
    }
}

customElements.define('packaging-options-selector', PackagingOptionsSelector);